package com.patronat.top.ui.atoms.inputs

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.*


enum class InputMessageType {
    Error,
    Alert
}

@Composable
fun InputMessage(
    text: String,
    type: InputMessageType = InputMessageType.Error,
    modifier: Modifier = Modifier
) {
    val (backgroundColor, contentColor, icon) = when (type) {
        InputMessageType.Error -> Triple(
            AlertErrorContainer, // White
            AlertErrorContent,   // AccentPink
            AppIcons.AlertCircle
        )
        InputMessageType.Alert -> Triple(
            AlertInfoContainer,  // Primary100 (Beige)
            AlertInfoContent,    // Primary600 (Brown)
            AppIcons.AlertCircle
        )
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(backgroundColor, RoundedCornerShape(6.dp))
            .padding(horizontal = 12.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = icon,
            contentDescription = null,
            tint = contentColor,
            modifier = Modifier.size(18.dp)
        )

        Spacer(modifier = Modifier.width(8.dp))

        Text(
            text = text,
            style = AlertMessageText,
            color = contentColor
        )
    }
}